module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Aerial View_RGB_lr.c20d2c2c.jpg";